/* giocodicoppia — landing: carrello, schede, copia, pulsante fisso */
(function () {
  'use strict';

  var cfgEl = document.getElementById('landing-config');
  var cfg = cfgEl ? cfgEl.dataset : {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Pulsanti d'acquisto: aggiungono il prodotto e aprono il pop-up dell'offerta ---------- */
  var variantId = cfg.variantBonus;
  function setLinks() {
    // Senza JavaScript il link porta direttamente al pagamento con il prodotto dentro
    var url = variantId ? root + 'cart/' + variantId + ':1' : '#offerta';
    document.querySelectorAll('[data-checkout]').forEach(function (a) { a.setAttribute('href', url); });
  }
  setLinks();

  (function offerPopup() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    if (!drawer || !variantId) return;
    var lastFocus = null, lockY = 0;
    var totalEl = drawer.querySelector('[data-cart-total]');
    var saveEl = drawer.querySelector('[data-cart-saving]');
    var euroFirst = /^\s*€/.test(totalEl ? totalEl.textContent : '');
    var money = function (cents) {
      var n = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
      return euroFirst ? '€' + n : n + ' €';
    };
    var rows = Array.prototype.slice.call(drawer.querySelectorAll('[data-bump]'));
    var num = function (el, attr) { return Number(el && el.getAttribute(attr)) || 0; };
    // Totale e risparmio calcolati dagli extra spuntati (prezzi in centesimi letti da Shopify)
    function paint() {
      var tot = num(totalEl, 'data-base'), save = num(saveEl, 'data-base');
      rows.forEach(function (row) {
        if (!row.classList.contains('added')) return;
        tot += num(row, 'data-price');
        save += num(row, 'data-compare') - num(row, 'data-price');
      });
      if (totalEl) totalEl.textContent = money(tot);
      if (saveEl) saveEl.textContent = money(save);
      return tot;
    }
    function setRow(row, on) {
      row.classList.toggle('added', on);
      row.setAttribute('aria-checked', on ? 'true' : 'false');
    }
    // Allinea le spunte al carrello reale e usa il totale di Shopify
    function syncBumps(cart) {
      rows.forEach(function (row) {
        var vid = row.getAttribute('data-bump');
        setRow(row, cart.items.some(function (i) { return String(i.variant_id) === vid; }));
      });
      paint();
      if (totalEl) totalEl.textContent = money(cart.total_price);
    }
    function lock() {
      lockY = window.scrollY || window.pageYOffset || 0;
      var b = document.body.style;
      b.position = 'fixed'; b.top = -lockY + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    }
    function unlock() {
      var b = document.body.style;
      b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
      var h = document.documentElement, sb = h.style.scrollBehavior;
      h.style.scrollBehavior = 'auto'; window.scrollTo(0, lockY); h.style.scrollBehavior = sb;
    }
    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('cd-open');
      lock();
      var body = drawer.querySelector('.pp-body'); if (body) body.scrollTop = 0;
      requestAnimationFrame(function () { drawer.classList.add('show'); overlay.classList.add('show'); });
    }
    function close() {
      if (!drawer.classList.contains('show')) return;
      drawer.classList.remove('show'); overlay.classList.remove('show');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('cd-open');
      unlock();
      setTimeout(function () { overlay.hidden = true; }, 250);
      if (lastFocus) lastFocus.focus({ preventScroll: true });
    }
    function json(url, body) {
      return fetch(root + url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    // Carrello con un solo pezzo del gioco: niente doppioni se il cliente clicca più volte
    function addOne() {
      return json('cart.js').then(function (cart) {
        var line = cart.items.filter(function (i) { return String(i.variant_id) === String(variantId); })[0];
        if (line && line.quantity === 1 && cart.item_count === 1) return cart;
        return json('cart/clear.js', {}).then(function () {
          return json('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
        }).then(function () { return json('cart.js'); });
      });
    }
    // Ogni richiesta manda lo stato completo (gioco = 1, extra = spuntati o 0).
    // Solo la risposta più recente aggiorna lo schermo: niente sfarfallii con tocchi veloci.
    var pending = null, seq = 0;
    function wanted() {
      var u = {}; u[variantId] = 1;
      rows.forEach(function (row) { u[row.getAttribute('data-bump')] = row.classList.contains('added') ? 1 : 0; });
      return u;
    }
    function push() {
      var my = ++seq;
      pending = (pending || Promise.resolve()).catch(function () {}).then(function () {
        return json('cart/update.js', { updates: wanted() });
      }).then(function (cart) {
        if (my === seq) syncBumps(cart);
        return cart;
      });
      return pending;
    }
    function toggleBump(row) {
      setRow(row, !row.classList.contains('added'));
      paint();
      push().catch(function () {
        return json('cart.js').then(function (c) { if (seq) syncBumps(c); return c; });
      });
    }
    rows.forEach(function (row) {
      row.addEventListener('click', function (e) { e.preventDefault(); toggleBump(row); });
      row.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggleBump(row); }
      });
    });
    document.querySelectorAll('[data-checkout]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var err = drawer.querySelector('[data-cart-error]'); if (err) err.hidden = true;
        // Nessun extra preselezionato: a ogni apertura si riparte dal solo gioco
        rows.forEach(function (row) { setRow(row, false); });
        paint();
        open();
        push().catch(function () {
          return addOne().then(function (c) { syncBumps(c); return c; });
        }).catch(function () { var er = drawer.querySelector('[data-cart-error]'); if (er) er.hidden = false; });
      });
    });
    var go = drawer.querySelector('[data-cart-go]');
    if (go) go.addEventListener('click', function (e) {
      if (!pending) return;
      e.preventDefault(); go.classList.add('loading');
      pending.then(function () { window.location.href = go.getAttribute('href'); },
                   function () { window.location.href = root + 'cart/' + variantId + ':1'; });
    });
    window.addEventListener('pageshow', function () { document.querySelectorAll('.loading').forEach(function (x) { x.classList.remove('loading'); }); });
    document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  })();

  /* ---------- Informative legali in finestra, senza uscire dalla landing ---------- */
  document.querySelectorAll('[data-policy]').forEach(function (a) {
    var dlg = document.getElementById(a.dataset.policy);
    if (!dlg || !dlg.showModal) return; // browser vecchi: si apre la pagina normale
    a.addEventListener('click', function (e) { e.preventDefault(); dlg.showModal(); dlg.querySelector('.pol-body').scrollTop = 0; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-policy-close]')) dlg.close();
    });
  });

  /* ---------- Copia negli appunti ---------- */
  document.querySelectorAll('.copy').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var box = btn.closest('.cbox');
      var src = box ? box.querySelector('[data-email]') : btn.previousElementSibling;
      var text = src ? src.textContent.trim() : '';
      var label = btn.dataset.label || (btn.dataset.label = btn.textContent);
      function done() {
        btn.textContent = 'Copiato';
        btn.classList.add('done');
        setTimeout(function () { btn.textContent = label; btn.classList.remove('done'); }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done, function () { fallback(text); done(); });
      } else { fallback(text); done(); }
    });
  });
  function fallback(text) {
    var ta = document.createElement('textarea');
    ta.value = text; document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    ta.remove();
  }

  /* ---------- Schede dei mazzi ---------- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    var tabs = Array.prototype.slice.call(group.querySelectorAll('.tab'));
    function select(t) {
      tabs.forEach(function (x) {
        var on = x === t;
        x.setAttribute('aria-selected', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(x.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(t); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          select(n); n.focus();
        }
      });
    });
  });

  /* Pulsante fisso: gestito da uno script dentro il footer, così si attiva subito */

  /* ---------- Animazione leggera allo scroll ---------- */
  (function () {
    var items = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { items.forEach(function (i) { i.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    items.forEach(function (i) { io.observe(i); });
  })();
})();
